import React, { useContext, useState } from 'react';
import styles from './ScanQrChecker.module.css';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header/Header';
import { WelletContext } from '../../context/WelletContext';
import { useParams } from 'react-router-dom';
import encodeQueryParams from '../../helpers/encodeUri';

import Button from '../../components/Common/Button/Button';
import ContentApp from '../ContentApp';

const ManualQrChecker = ({ history }) => {
  const welletContext = useContext(WelletContext);
  const { t } = useTranslation();
  const { id } = useParams();
  const [referenceCode, setReferenceCode] = useState('');

  const checkin = async (referenceCode) => {
    try {
      const result = await welletContext.apis.tickets.post(
        `/api/checkin/CheckInTicket?check=${false}`,
        {
          ReferenceCode: referenceCode,
          Token: null,
          EventId: id,
          DeviceId: null,
        },
      );

      const params = {
        referenceCode,
        id,
        showName: result.data.ticketCheck.name,
        codeTicket: result.data.ticketCheck.referenceCode,
      };

      const path = result.data.success
        ? `/qr-manual-exit?${encodeQueryParams(params)}`
        : `/qr-scan-error?${encodeQueryParams({
            ...params,
            errorType: result.data.errorType,
          })}`;

      history.push(path);
    } catch (error) {
      console.error(error);
      history.push(`/qr-scan-error?${encodeQueryParams({ referenceCode, id })}`);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (referenceCode) {
      checkin(referenceCode);
    } else {
      alert(t('Por favor, ingresa un código válido.'));
    }
  };

  return (
    <>
      <Header pathName={`/scan-qr-checker/${id}`} title={'Check-in Manual'}/>
      <div className={styles.manualQrCheck}>
        <div className={styles.manualQr}>
          <ContentApp>
            <div>
              <form onSubmit={handleSubmit} className={'text-center'}>
                <input 
                  className={styles.fieldBorderInput}
                  type='text'
                  value={referenceCode}
                  onChange={(e) => setReferenceCode(e.target.value)}
                  placeholder={t('entertheCode')}
                  style={{color:'#000'}}
                />
                <div className='mt-3 mb-2'>
                  <Button size={'normal'} text={t('verifyCode')} type='submit' />
                </div>
              </form>
            </div>
          </ContentApp>
        </div>
      </div>
    </>
  );
};

export default ManualQrChecker;
